import { Col, Row, Container, Card } from "react-bootstrap";
import storage from "helpers/storage";

import { DataTable } from "./DataTable";

export const Inspections = () => {
  const userInformation: any = storage.getData("user-info");

  const userId = userInformation.id;
  return (
    <section className="profile-main pt-4 dashboard-content">
      <Container className="">
        <Row>
          <Col md={12} lg={12}>
            <h1 className="fs-30 fw-bold mb-3 mt-2 black-color">
              Inspections - Machines / Devices
            </h1>
          </Col>
          <Col md={12} lg={12}>
            <Card className="border-0 mb-3">
              <DataTable userId={userId} />
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
